
    <template>
      <section class="relax-doc">
        <h1>Carousel 轮播</h1>
<blockquote>
<p>以轮播的方式显示一组元素，非常经典</p>
</blockquote>
<h2 id="yan-shi"><a class="header-anchor" href="#yan-shi"></a> 演示</h2>
<blockquote>
<p>默认</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo0 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-carousel width=&quot;500px&quot; height=&quot;250px&quot;&gt;
    &lt;x-carousel-item class=&quot;demo-carousel&quot; v-for=&quot;item in 4&quot;&gt;
      {{item}}
    &lt;/x-carousel-item&gt;
  &lt;/x-Carousel&gt;
&lt;/template&gt;
</code></pre></template></demo-block><h2 id="zi-dong-bo-fang"><a class="header-anchor" href="#zi-dong-bo-fang"></a> 自动播放</h2>
<blockquote>
<p>设置 <code>autoplay</code> 开启自动播放</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo1 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-carousel width=&quot;500px&quot; height=&quot;250px&quot; autoplay&gt;
    &lt;x-carousel-item class=&quot;demo-carousel&quot; v-for=&quot;item in 4&quot;&gt;
      {{item}}
    &lt;/x-carousel-item&gt;
  &lt;/x-Carousel&gt;
&lt;/template&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
      import hljs from 'highlight.js'
      import * as Vue from "vue"
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    const { renderList: _renderList, Fragment: _Fragment, openBlock: _openBlock, createElementBlock: _createElementBlock, toDisplayString: _toDisplayString, createTextVNode: _createTextVNode, resolveComponent: _resolveComponent, withCtx: _withCtx, createVNode: _createVNode, createBlock: _createBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_carousel_item = _resolveComponent("x-carousel-item")
  const _component_x_carousel = _resolveComponent("x-carousel")

  return (_openBlock(), _createBlock(_component_x_carousel, {
    width: "500px",
    height: "250px"
  }, {
    default: _withCtx(() => [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (item) => {
        return _createVNode(_component_x_carousel_item, { class: "demo-carousel" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(item), 1)
          ]),
          _: 2
        }, 1024)
      }), 64))
    ]),
    _: 1
  }))
}
  
    const democomponentExport = {}
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo1": (function() {
    
    const { renderList: _renderList, Fragment: _Fragment, openBlock: _openBlock, createElementBlock: _createElementBlock, toDisplayString: _toDisplayString, createTextVNode: _createTextVNode, resolveComponent: _resolveComponent, withCtx: _withCtx, createVNode: _createVNode, createBlock: _createBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_carousel_item = _resolveComponent("x-carousel-item")
  const _component_x_carousel = _resolveComponent("x-carousel")

  return (_openBlock(), _createBlock(_component_x_carousel, {
    width: "500px",
    height: "250px",
    autoplay: ""
  }, {
    default: _withCtx(() => [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (item) => {
        return _createVNode(_component_x_carousel_item, { class: "demo-carousel" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(item), 1)
          ]),
          _: 2
        }, 1024)
      }), 64))
    ]),
    _: 1
  }))
}
  
    const democomponentExport = {}
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  